module.exports = __webpack_public_path__ + "static/media/new16.36b668c3.ico";